import React from "react";
import '../../App.css'
import OurPeopleFormCard from "../OurPeopleFormCard";
import TShirtForm from "../TShirtForm";
import ContactUs from "../ContactUs";
export default function OurPeopleForm(){
    return (
        <>
            <OurPeopleFormCard />
            <ContactUs />
        </>

    )
}